import Link from 'next/link';

type NameProps = {
  href: string;
  item: {
    name?: string;
    shortName?: string;
  };
};

const TeamName = ({ href, item }: NameProps) => {
  const fullName = item.name ?? item.shortName ?? '';
  const shortName = item.shortName ?? '';

  return (
    <Link
      href={href}
      className="inline-flex flex-col leading-tight text-neutral-800 hover:text-primary-700 transition-colors"
    >
      <span className="text-xs font-semibold tracking-tight">{fullName}</span>
      {shortName && shortName !== fullName && (
        <span className="text-[10px] font-medium uppercase tracking-[0.08em] text-neutral-400">
          {shortName}
        </span>
      )}
    </Link>
  );
};

export default TeamName;
